import React, { FC } from 'react'
import { CMSStaticSection } from './../../../models'
import { Col, Collapse, Row } from 'antd'
import './JCMSStaticFaqTemplate.scss'
import { JCMSIcon } from '../../../JCMSIcon'
import {UpCircleFilled, UpOutlined} from '@ant-design/icons'
import { JCollapse } from '../../../JCollapse'
import { JHTML } from '../../../JHTML'

export const FaqRow: FC<{ left: JSX.Element, right: JSX.Element }> = (props) => {
    return (
        <Row>
            <Col xs={5} sm={2} lg={2}>
                {props.left}
            </Col>
            <Col xs={19} sm={22} lg={22}>
                {props.right}
            </Col>
        </Row>
    )
}
const { Panel } = Collapse;

export interface JCMSStaticFaqTemplateProps extends CMSStaticSection.FaqTemplate { }

export const JCMSStaticFaqTemplate: FC<JCMSStaticFaqTemplateProps> = props => {
    if (!props.enabled) return <></>

    const enabledSections = props.sections.filter(s => s.enabled !== false)
    return (
        <div className='jcms-static-faq-container'>
            <JCollapse
                ghost
                expandIcon={(acc: any) =>
                    <UpCircleFilled className="jcms-static-faq-arrow-collapse" aria-hidden={true} rotate={acc?.isActive ? 0 : 180} />
                }
                expandIconPosition="end">
                {
                    enabledSections.map((section, i) => {

                        const faqSections = section.sections?.length ? (
                            section.sections.filter(s => s.enabled !== false)
                        ) : ([])

                        return (
                            <Panel
                                header={
                                    <div className="jcms-static-faq-panel-title"> {section?.title} </div>
                                }
                                key={i}
                            >
                                {
                                    faqSections.map((faq, x) => {
                                        return (
                                            <Collapse
                                                key={x}
                                                className="jcms-static-faq-collapse-child"
                                                ghost
                                                expandIcon={(acc: any) =>
                                                    <UpOutlined aria-hidden={true} className="jcms-static-faq-second-icon" rotate={acc?.isActive ? 0 : 180} />
                                                }
                                                expandIconPosition="end"
                                            >
                                                <Panel
                                                    key={`${i}-${x}`}
                                                    header={
                                                        <FaqRow
                                                            left={
                                                                <span aria-hidden={true}>
                                                                    {
                                                                        !!faq.image?.length && (
                                                                            <JCMSIcon image={faq.image} />
                                                                        )
                                                                    }
                                                                </span>
                                                            }
                                                            right={(
                                                                <div className="jcms-static-faq-question-title">
                                                                    <div>{faq.title || ''}</div>
                                                                </div>
                                                            )}
                                                        />
                                                    }
                                                    className='jcms-static-faq-collapse-panel-faq'
                                                >
                                                    <FaqRow
                                                        left={<span aria-hidden={true} />}
                                                        right={(
                                                            <div className="jcms-static-faq-text">
                                                                <JHTML.Text html={faq.text || ''} />
                                                            </div>
                                                        )}
                                                    />
                                                </Panel>
                                            </Collapse>
                                        )
                                    })
                                }
                            </Panel>
                        )
                    })}
            </JCollapse>
        </div>
    )
}